// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__mf3yT","description":"MealItem_description__khXbc","price":"MealItem_price__2IMkY"};